module.exports = __webpack_public_path__ + "media/images/top/qa/office_search_banner_sp-9a780507252d265604d46bac7460ec07.png";